import * as React from 'react';
import { TextField as MaterialTextField, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    textField: {
        width: props => (props as TextFieldStyleProps).textFieldWidth + 'px',
        '& input': {
            height: '1rem',
            fontSize: '20px !important',
            padding: '12px',
        },
    },
    label: {
        textAlign: 'left',
    }
});

export enum TextFieldLabelPosition {
    Left,
    Top,
    None,
}

export type TextFieldChangeHandler = (newValue: string) => any;

export type TextFieldStyleProps = {
    textFieldWidth: number
}

export interface TextFieldProps {
    type: string | null;
    label: string | null;
    text: string;
    width: number;
    disabled: boolean;
    labelPosition: TextFieldLabelPosition;
    onChangeHandler: TextFieldChangeHandler;
}

const TextField = (props: TextFieldProps) => {
    const { type, label, text, width, disabled, labelPosition, onChangeHandler } = props;
    const classes = useStyles({ textFieldWidth: width });
    const [value, setValue] = React.useState<string>(text);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (type === 'number_0_to_100') {
            if (event.target.validity.valid || event.target.value === '') {
                setValue(event.target.value);
                onChangeHandler(event.target.value);
            }
        }
        else if (type === 'month') {
            if (event.target.value.length < 3) {
                setValue(event.target.value);
                onChangeHandler(event.target.value);
            }
        }
        else if (type === 'year') {
            if (event.target.value.length < 5) {
                setValue(event.target.value);
                onChangeHandler(event.target.value);
            }
        }
        else if (type ===  'number') {
            var val = event.target.value;

            if (val.charAt(0) === ".") {
                setValue(event.target.value);
                onChangeHandler(event.target.value);
            }
            else {
                var value = Math.round(parseFloat(event.target.value))
                if (value <= 0) {
                    setValue("");
                    onChangeHandler("");
                }
                else {
                    setValue(event.target.value);
                    onChangeHandler(event.target.value);
                }
            }
        }
        else {
            setValue(event.target.value);
            onChangeHandler(event.target.value);
        }
    };

    return (
        <div>
            {label === null &&
                <div>
                    {type !== null && (type !== 'number_0_to_100' && type !== 'month' && type !== 'year') &&
                        <MaterialTextField
                            id={"text-field-"+label}
                            type={type}
                            aria-labelledby={"text-label-"+label}
                            onChange={handleChange}
                            className={classes.textField}
                            disabled={disabled}
                            variant="outlined"
                            margin="normal"
                            value={value} />
                    }
                    {type !== null && type === 'number_0_to_100' &&
                        <MaterialTextField
                            id={"text-field-"+label}
                            type="tel"
                            aria-labelledby={"text-label-"+label}
                            onChange={handleChange}
                            className={classes.textField}
                            disabled={disabled}
                            variant="outlined"
                            margin="normal"
                            value={value}
                            error={parseInt(value) < 1}
                            helperText={ parseInt(value) < 1 ? 'Min. 1' : '' }
                            inputProps={{
                                pattern: "^[1-9]$|^[1-9][0-9]$|^(100)$",
                            }} />
                    }
                    {type !== null && type === 'month' &&
                        <MaterialTextField
                            id={"text-field-"+label}
                            type="tel"
                            aria-labelledby={"text-label-"+label}
                            onChange={handleChange}
                            className={classes.textField}
                            disabled={disabled}
                            variant="outlined"
                            margin="normal"
                            value={value}
                            inputProps={{
                                pattern: "^(0[1-9]|1[0-2])$",
                            }} />
                    }
                    {type !== null && type === 'year' &&
                        <MaterialTextField
                            id={"text-field-"+label}
                            type="tel"
                            aria-labelledby={"text-label-"+label}
                            onChange={handleChange}
                            className={classes.textField}
                            disabled={disabled}
                            variant="outlined"
                            margin="normal"
                            value={value}
                            inputProps={{
                                pattern: "^(20)\d{2}$",
                            }} />
                    }
                    {type === null &&
                        <MaterialTextField
                            id={"text-field-"+label}
                            aria-labelledby={"text-label-"+label}
                            onChange={handleChange}
                            className={classes.textField}
                            disabled={disabled}
                            variant="outlined"
                            margin="normal"
                            value={value} />
                    }
                </div>
            }
            {label !== null &&
                <div>
                    {labelPosition === TextFieldLabelPosition.Top &&
                        <div>
                            <div>
                                <Typography id={"text-label-"+label} variant="caption">
                                    {label}
                                </Typography>
                            </div>
                            {type !== null &&
                                <MaterialTextField
                                    id={"text-field-"+label}
                                    type={type}
                                    aria-labelledby={"text-label-"+label}
                                    onChange={handleChange}
                                    className={classes.textField}
                                    disabled={disabled}
                                    variant="outlined"
                                    margin="normal"
                                    value={value} />
                            }
                            {type === null &&
                                <MaterialTextField
                                    id={"text-field-"+label}
                                    aria-labelledby={"text-label-"+label}
                                    onChange={handleChange}
                                    className={classes.textField}
                                    disabled={disabled}
                                    variant="outlined"
                                    margin="normal"
                                    value={value} />
                            }
                        </div>
                    }
                    
                    {labelPosition === TextFieldLabelPosition.Left &&
                        <Typography id={"text-label-"+label} className={classes.label}>
                            {label}
                            {type !== null &&
                                <MaterialTextField
                                    id={"text-field-"+label}
                                    type={type}
                                    aria-labelledby={"text-label-"+label}
                                    onChange={handleChange}
                                    className={classes.textField}
                                    disabled={disabled}
                                    variant="outlined"
                                    margin="normal"
                                    value={value} />
                            }
                            {type === null &&
                                <MaterialTextField
                                    id={"text-field-"+label}
                                    aria-labelledby={"text-label-"+label}
                                    onChange={handleChange}
                                    className={classes.textField}
                                    disabled={disabled}
                                    variant="outlined"
                                    margin="normal"
                                    value={value} />
                            }
                        </Typography>
                    }
                </div>
            }
            
        </div>
    );
}

export default TextField;